module.exports = [
    {
        "title": "工商信息",
        "contents": [
            {
                "text": "全称：北京五八钱柜信息技术有限公司"
            },
            {
                "text": "简称：钱柜"
            },
            {
                "text": "统一社会信用代码：91110108355223190U"
            },
            {
                "text": "公司注册资本：1,000,000,000.00元"
            },
            {
                "text": "实缴注册资本：50,000,000.00元"
            },
            {
                "text": "公司经营地：北京市海淀区学清路甲18号中关村东升科技园学院园三层302室"
            },
            {
                "text": "公司成立时间：2015-08-24"
            },
            {
                "text": "公司经营期限：2015-08-24 至 2045-08-23"
            },
            {
                "text": "公司经营状态：存续"
            },
            {
                "text": "法定代表人：常利刚"
            },
            {
                "text": "实际控制人：姚劲波"
            },
            {
                "text": "营业执照：",
                "link": "点击查看",
                "href": "//j1.58cdn.com.cn/jinrong/licai/pc/%E4%BA%94%E5%85%AB%E9%92%B1%E6%9F%9C%E8%90%A5%E4%B8%9A%E6%89%A7%E7%85%A7.pdf"
            },
            {
                "text": "经营范围：技术开发、技术咨询、技术推广、技术服务；计算机系统服务；数据处理（数据处理中的银行卡中心、PUE值在1.5以上的云计算数据中心除外）；基础软件服务；应用软件服务；软件开发；财务咨询（不得开展审计、验资、查帐、评估、会计咨询、代理记账等需经专项审批的业务，不得出具相应的审计报告、验资报告、查帐报告、评估报告等文字材料）；经济贸易咨询；市场调查；会议服务；承办展览展示活动；企业管理咨询；企业策划；投资咨询；投资管理；火车票销售代理；销售软件及辅助设备；第二类增值电信业务中的信息服务业务（仅限互联网信息服务；互联网信息服务不含新闻、出版、教育、医疗保健、药品和医疗器械、电子公告服务）。（依法须经批准的项目，经相关部门批准后依批准的内容开展经营活动。）"
            }
        ]
    },
    {
        "title": "注册协议模板",
        "contents": [
            {
                "link": "《钱柜注册协议》",
                "href": "//j1.58cdn.com.cn/jinrong/licai/pc/%E4%BA%94%E5%85%AB%E9%92%B1%E6%9F%9C%E6%B3%A8%E5%86%8C%E6%9C%8D%E5%8A%A1%E5%8D%8F%E8%AE%AE.pdf"
            },
        ]
    },
    {
        "title": "股东信息",
        "contents": [
            {
                "text": "股东名称及占股比例：天津五八金服有限公司 100%"
            }
        ]
    },
    {
        "title": "管理团队",
        "contents": [
            {
                "text": "法人：常利刚"
            },
            {
                "text": "实际控制人：姚劲波"
            },
            {
                "text": "董事长兼总经理：张垚"
            },
            {
                "text": "监事：李鹏"
            },
            {
                "text": "业务总监：杜鹏"
            },
            {
                "text": "技术总监：曹品武"
            },
            {
                "text": "风控总监：孙方博"
            }
        ]
    },
    {
        "title": "组织结构及从业人员概况",
        "contents": [
            {
                "text": "组织结构",
            },
            {
                "imgText": "组织结构",
                "imgSrc": "//j1.58cdn.com.cn/jinrong/licai/pc/organization_pc.png?t=2"
            },
            {
                "text": "从业人员",
                "subTexts": [
                    "共300+人",
                    "其中，风控人员50+人，技术人员200+人",
                    "其中，硕士50+人，本科250+人，专科及以下0人"
                ]
            }
        ]
    },
    {
        "title": "分支机构",
        "contents": [
            {
                "text": "无分支机构"
            }
        ]
    },
    {
        "title": "渠道信息",
        "contents": [
            {
                "text": "平台上线运营时间：2015年5月8日"
            },
            {
                "text": "公司官网地址：58钱柜 http://www.qiangui.com"
            },
            {
                "text": "公司官网IP地址：115.159.231.141"
            },
            {
                "text": "平台APP：钱柜"
            },
            {
                "text": "其他渠道：",
                "subTexts": [
                    "微信服务号『58钱柜』",
                    "微信订阅号『58金融』",
                    "网站『58金融-58钱柜』https://qiangui.58.com/help/58hb?from=58_PC"
                ]
            }
        ]
    }
]


// WEBPACK FOOTER //
// ./src/config/InfoDcs/Team.js